import { render, staticRenderFns } from "./PayoutLimitView.vue?vue&type=template&id=fd854d12&"
import script from "./PayoutLimitView.vue?vue&type=script&lang=js&"
export * from "./PayoutLimitView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports